import type {
  CSSProperties,
  DragEventHandler,
  MouseEventHandler,
  PointerEventHandler,
  ReactNode,
  RefObject,
} from "react";
import "./NodeCanvas.scss";

type NodeCanvasProps = {
  canvasRef: RefObject<HTMLDivElement | null>;
  children: ReactNode;
  onClick: MouseEventHandler<HTMLDivElement>;
  onContextMenu: MouseEventHandler<HTMLDivElement>;
  onDragOver: DragEventHandler<HTMLDivElement>;
  onDrop: DragEventHandler<HTMLDivElement>;
  onPointerDown: PointerEventHandler<HTMLDivElement>;
  canvasWidth: number;
  canvasHeight: number;
};

export function NodeCanvas({
  canvasRef,
  children,
  onClick,
  onContextMenu,
  onDragOver,
  onDrop,
  onPointerDown,
  canvasWidth,
  canvasHeight,
}: NodeCanvasProps) {
  return (
    <div
      className="node-canvas canvas workflow-grid"
      ref={canvasRef}
      onPointerDown={onPointerDown}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      <div
        className="canvas-surface"
        style={
          {
            "--canvas-width": `${canvasWidth}px`,
            "--canvas-height": `${canvasHeight}px`,
          } as CSSProperties
        }
      >
        {children}
      </div>
    </div>
  );
}
